import Swiper from 'swiper';

class PodcastsBestSlider {

	constructor() {
		new Swiper('.podcasts--best--list', {
			loop: false,
			grabCursor: true,
			slidesPerView: 'auto',
			spaceBetween: 0
		})
	}
}

export default PodcastsBestSlider;
